import axios from './axios'
import Vue from 'vue'
const util = require('util')

export default {
    summary:function(){
        var api = "/user/summary/rent";
        return axios.get(api)
        .then(
          function(response){
            return response.data;
          }
        )
        .catch(function (error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
    },
    openid(){
      var api = `/user/openid/rent`;
      return axios.get(api).then(
        res=>{
          return res.data;})
    },

  deleteWechatInfo(){
    var api = `/user/openid/deleteWechatInfo`;
    return axios.post(api).then(
      res=>{
        return res.data;})
  },
  codeurl(returnUrl){
    var api = "/mp/codeurl";
    returnUrl = encodeURIComponent(returnUrl);
    return axios.get(api,{params:{returnUrl:returnUrl}})
      .then(res=> {
        return res.data;
      })
      .catch(error=>{
        console.log(error);

      });
  },
  codeUrlForOpenID(returnUrl){
    var api = "/mp/codeurlforOpenID";
    returnUrl = encodeURIComponent(returnUrl);
    return axios.get(api,{params:{returnUrl:returnUrl}})
      .then(res=> {
        return res.data;
      })
      .catch(error=>{
        console.log(error);

      });
  },
  getCodeUrlForWechatLogin(returnUrl){
    var api = "/mp/getCodeUrlForWechatLogin";
    returnUrl = encodeURIComponent(returnUrl);
    return axios.get(api,{params:{returnUrl:returnUrl}})
      .then(res=> {
        return res.data;
      })
      .catch(error=>{
        console.log(error);

      });
  },
  // 绑定微信后获取用户信息
  getCurUserMsg(){
    var api = "/user/wechat/rent/current";
    return axios.get(api)
      .then(res=> {
        return res.data;
      })
      .catch(error=>{
        console.log(error);

      });
  },
  getCurUserGuide(){
    var api = "/user/summary/report/rent";
    return axios.get(api)
      .then(res=> {
        return res.data;
      })
      .catch(error=>{
        console.log(error);
      });
  }
} 



// WEBPACK FOOTER //
// ./src/api/user.js